let {systemVar, apiConfig, websdkParams} = require('./vpadn-sdk-parameters.partial')

const divide = (length, bandCount) => {
  var res = []
  for (var i = 0; i <= bandCount; i++) {
    res[i] = (length / bandCount) * i
  }

  return res
}

const coveredBannerCheck = (frame_id, vponTag) => {
    // iframe is display:none or visibity:hidden
  if (!iframeViewable(frame_id)) {
    return false
  }

  if (!isInCrossDomain()) {
    // iframe should be under the viewport. check the left and top will be inisde in the viewport.
    if (!underViewport(frame_id, vponTag)) {
      return false
    }

    // iframe should be displayed fully in viewport
    // the viewport should completely contain the right and bottom of iframe
    if (!displayInViewport(frame_id, vponTag)) {
      return false
    }
  }
  return true
}

const iframeViewable = (frame_id) => {
  var myframe = document.getElementById(frame_id)
    // check display:none
  var displayStatus = myframe.style.display
  if (displayStatus.toLowerCase() == 'none') {
    return false
  }
    // check visibility:hidden
  var visibilityStatus = myframe.style.visibility
  if (visibilityStatus.toLowerCase() == 'hidden') {
    return false
  }

  return true
}

const underViewport = (frame_id, vponTag) => {
  var myframe = document.getElementById(frame_id)
  var rect = myframe.getBoundingClientRect()
  var rectTop = getTransferRectHeight(rect.top, vponTag, '+')
  var rectLeft = getTransferRectWidth(rect.left, vponTag, '+')
  var frameBoundingClientRect = {
    fTop: 0,
    fLeft: 0
  }
  frameBoundingClientRect = getFrameBoundingClientRect(window, frameBoundingClientRect)
  rectTop = frameBoundingClientRect.fTop + rectTop
  rectLeft = frameBoundingClientRect.fLeft + rectLeft
  return (rectTop >= 0 && rectLeft >= 0)
}

const displayInViewport = (frame_id, vponTag) => {
  var myframe = document.getElementById(frame_id)
  var rect = myframe.getBoundingClientRect()

  var rectBottom = getTransferRectHeight(rect.bottom, vponTag, '-')
  var rectRight = getTransferRectWidth(rect.right, vponTag, '-')

  var flag1 = (window.innerHeight - rectBottom >= 0 && window.innerWidth - rectRight >= 0)
  if (window == top) {
    return flag1
  } else if (flag1) { // in iframe
    var frameBoundingClientRect = {
      fTop: 0,
      fLeft: 0
    }
    var frameBoundingClientRect = getFrameBoundingClientRect(window, frameBoundingClientRect)
    rectBottom = frameBoundingClientRect.fTop + rectBottom
    rectRight = frameBoundingClientRect.fLeft + rectRight

    var flag2 = (window.top.innerHeight - rectBottom >= 0 && window.top.innerWidth - rectRight >= 0)
    return flag2
  } else {
    return false
  }
}

const getFrameBoundingClientRect = (nowFrame, frameBoundingClientRect) => {
  if (nowFrame == top) {
    return frameBoundingClientRect
  } else {
    frameBoundingClientRect = calIframeBoundingClientRect(nowFrame.parent.document, nowFrame.document, frameBoundingClientRect)
    return getFrameBoundingClientRect(nowFrame.parent, frameBoundingClientRect)
  }
}

const calIframeBoundingClientRect = (frameDocument, nowDocument, frameBoundingClientRect) => {
  var ifs = frameDocument.getElementsByTagName('iframe')
    // var isSafeFrame = /safeframe/;
  if (ifs) {
    for (var i = 0, len = ifs.length; i < len; i++) {
      try {
        var f = ifs[i].contentWindow.document || ifs[i].contentDocument
      } catch (e) {
        continue
      }

      var f = ifs[i]
      var fDoc = f.contentDocument || f.contentWindow.document
      if (fDoc === nowDocument) {
        var rect = f.getBoundingClientRect()
        frameBoundingClientRect.fTop = frameBoundingClientRect.fTop + rect.top
        frameBoundingClientRect.fLeft = frameBoundingClientRect.fLeft + rect.left
        return frameBoundingClientRect
      }
    }
  } else {
    return frameBoundingClientRect
  }
}

function currentFrameAbsolutePosition() {
  let currentWindow = window;
  let currentParentWindow;
  let positions = [];
  let rect;

  while (currentWindow !== window.top) {
    currentParentWindow = currentWindow.parent;
    for (let idx = 0; idx < currentParentWindow.frames.length; idx++)
      if (currentParentWindow.frames[idx] === currentWindow) {
        for (let frameElement of currentParentWindow.document.getElementsByTagName('iframe')) {
          if (frameElement.contentWindow === currentWindow) {
            rect = frameElement.getBoundingClientRect();
            positions.push({x: rect.x, y: rect.y});
          }
        }
        currentWindow = currentParentWindow;
        break;
      }
  }
  return positions.reduce((accumulator, currentValue) => {
    return {
      x: accumulator.x + currentValue.x,
      y: accumulator.y + currentValue.y
    };
  }, { x: 0, y: 0 });
}

const coveredIntCheck = (frame_id) => {
  var iframeTag = document.getElementById(frame_id)

  var rectWidthBand = divide(document.documentElement.clientWidth -1, systemVar.rectWidthTotalBand)
  var rectHeightBand = divide(document.documentElement.clientHeight -1, systemVar.rectHeightTotalBand)

  var notPass = 0 // count how many point wont pass
  var threshold = ((systemVar.rectWidthTotalBand + 1) * (systemVar.rectHeightTotalBand + 1)) * (0.5) // threshold: 50%

  for (var i = 0; i <= systemVar.rectWidthTotalBand; i++) {
    var checkX = rectWidthBand[i]

    for (var j = 0; j <= systemVar.rectHeightTotalBand; j++) {
      var checkY = rectHeightBand[j]

      var el = document.elementFromPoint(checkX, checkY)

      if (el === null) {
        notPass++
        continue
      }
      var frameId = el.getAttribute('id')
      if (frame_id != frameId) {
        notPass++
        continue
      }
    }
  }
  if (notPass > threshold) {
    return false
  } else {
    return true
  }
}

const coveredNaCheck = ((vponTag) => {
  return function (vponTag) {
    if(window.top == window.self){
      var vponTagPos = vponTag.getBoundingClientRect()
      var rectWidthBand = divide(vponTagPos.width -1, systemVar.rectWidthTotalBand)
      var rectHeightBand = divide(vponTagPos.height -1, systemVar.rectHeightTotalBand)
      var scrollTop = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
      var scrollLeft = (window.pageXOffset !== undefined) ? window.pageXOffset : (document.documentElement || document.body.parentNode || document.body).scrollLeft;
      var notPass = 0 // count how many point wont pass
      var threshold = ((systemVar.rectWidthTotalBand + 1) * (systemVar.rectHeightTotalBand + 1)) * (0.5) // threshold: 50%

      for (var i = 0; i <= systemVar.rectWidthTotalBand; i++) {
        var checkX = vponTagPos.x + rectWidthBand[i]

        for (var j = 0; j <= systemVar.rectHeightTotalBand; j++) {
          var checkY = vponTagPos.y + rectHeightBand[j]

          var el = document.elementFromPoint(checkX, checkY)

          if (el === null) {
            notPass++
            continue
          }
          var className = el.className
          var parentClassName = el.parentElement ? el.parentElement.className : undefined // while user click on image tag
          if ( className ? className.indexOf('vpon') < 0 : true && parentClassName ? parentClassName.indexOf('vpon') < 0 : true) {
            notPass++
            continue
          }

        }
      }
      if (notPass > threshold) return false
      else return true
    }else{
      var rectBottom = currentFrameAbsolutePosition().y + (vponTag.getBoundingClientRect().height/2)
      var rectRight = currentFrameAbsolutePosition().x + (vponTag.getBoundingClientRect().width/2);
      if(window.top.innerHeight - rectBottom >= 0 && window.top.innerWidth - rectRight >= 0) return true
      else return false
    }
  }
}) ()

const getTransferRectWidth = (length, vponTag, direction) => {
  var reqAdParameters = getReqAdParameters(vponTag)
  var iframeW = reqAdParameters.format.split('x')[0]
  var iframeH = reqAdParameters.format.split('x')[1].split('_')[0]

  var rectWidthBand = divide(iframeW, systemVar.rectWidthTotalBand)
  var result = 0
  if (direction == '+') {
    result = length + rectWidthBand[systemVar.useWidthBand]
  } else if (direction == '-') {
    result = length - rectWidthBand[systemVar.useWidthBand]
  }
  return result
}

const getTransferRectHeight = (length, vponTag, direction) => {
  var reqAdParameters = getReqAdParameters(vponTag)
  var iframeW = reqAdParameters.format.split('x')[0]
  var iframeH = reqAdParameters.format.split('x')[1].split('_')[0]

  var rectHeightBand = divide(iframeH, systemVar.rectHeightTotalBand)
  var result = 0
  if (direction == '+') {
    result = length + rectHeightBand[systemVar.useHeightBand]
  } else if (direction == '-') {
    result = length - rectHeightBand[systemVar.useHeightBand]
  }
  return result
}
// -------- cover check ----------

// --- precheck vpon tag attribute ---
const checkInput = (vponTag) => {
  var result = {
    errMsg: '',
    adhesionPosition: false
  }

  var licensekey = vponTag.getAttribute(systemVar.licensekey)
  if (!checkAttributeIsGiven(licensekey)) {
    result.errMsg += 'input licensekey is empty. '
  }
  var regex = /^[A-Za-z0-9]{32}$/;
  if (!regex.test(licensekey)) {
    result.errMsg += 'input licensekey error length. '
  }

  result.adType = checkAdType(vponTag)

  var adhesionPosition = vponTag.getAttribute(systemVar.adhesionPosition)
  if (adhesionPosition) {
    if (adhesionPosition === 'top') {
      result.adhesionPosition = 'top'
    } else if (adhesionPosition === 'bottom') {
      result.adhesionPosition = 'bottom'
    } else {
      result.adhesionPosition = 'unknown'
    }
  } else {
    result.adhesionPosition = false
  }

  return result
}

/**
 * Check ad type
 * @param {element} vponTag vpon tag element
 * @returns {string|undefined} ad type string
 */
const checkAdType = (vponTag) => {
  if (vponTag.getAttribute(websdkParams.format) === null) {
    throw new TypeError("[Vpon-WebSDK] format attribute is null");
  }

  const format = vponTag.getAttribute(websdkParams.format).toLowerCase();
  const adTypeMapping = {
    mi: ["mi"],
    banner: ["320x50_mb", "320x100_mb", "300x250_mb", "320x480_mb", "970x250_mb"],
    na: ["na"],
  };
  const result = Object.keys(adTypeMapping).find((key) => {
    return adTypeMapping[key].indexOf(format) !== -1;
  });

  if (!result) {
    throw new TypeError("[Vpon-WebSDK] format attribute is unable to mapping");
  }

  return result;
};

// precheck vpon tag attribute 'vpon_ad_licensy_key'
const checkAttributeIsGiven = (attr) => {
  if (undefined != attr && attr.trim() != '') {
    return true
  } else {
    return false
  }
}

// --- precheck vpon tag attribute ---

// --- <START> check will generate ad or not ---

/**
 * confirm vpon tag exist
 * @returns {boolean} result
 */
const checkVponTagExisted = () => {
  const vponTag = document.querySelectorAll("vpon");
  return Boolean(vponTag.length);
};

const isInCrossDomain = () => {
  try {
    window.top.document;
    return false;
  } catch (err) {
    return true;
  }
}

const getReqAdParameters = (vponTag) => {

  var reqParameters = {}

  var adType = checkAdType(vponTag)
  if (adType == 'na') reqParameters.cover_min = vponTag.getAttribute(systemVar.nativeCoverMin) || ''
  reqParameters.format = vponTag.getAttribute(systemVar.format)
  reqParameters.sdk = systemVar.sdk
  reqParameters.bid = vponTag.getAttribute(systemVar.licensekey)
  reqParameters.adtest = vponTag.getAttribute('vpon_ad_test') == 1 ? 1 : 0
  reqParameters.adRequestCallBack = vponTag.getAttribute(systemVar.adRequestCallBack) || null // branch:requestAdCallback
  reqParameters.isRotate = vponTag.getAttribute(systemVar.isRotate) || 'true' // branch:requestAdCallback
  reqParameters.s_h = document.documentElement.clientHeight
  reqParameters.s_w = document.documentElement.clientWidth

  return reqParameters
}

const arrangeReqAdUrl = (baseUrl, reqParameters) => {
    // 1. arrange reqParams
  var param_str = ''
  if (reqParameters) {
    for (var key in reqParameters) {
      param_str += key + '=' + encodeURIComponent(reqParameters[key]) + '&'
    }
    param_str = '?' + param_str.substring(0, param_str.length - 1)
  }
    // 2. combine
  var reqAdURLWithQueryString = baseUrl + param_str
  return `//${reqAdURLWithQueryString}`
}

const queryWebApiPermission = async (name) => {
  return await navigator.permissions.query({name});
}

const isUrl = (url) => {
  try {
    if (new URL(url)) {
      return true;
    } else {
      return false;
    }
  } catch(error) {
    return false;
  }
}

const isVpadnEndpoint = (url) => {
  if (!isUrl(url)) {
    return false;
  }

  const urlObj = new URL(url);

  return urlObj.hostname === apiConfig.hostname;
}

const isWebview = () => {
  const useragent = navigator.userAgent;
  const regex = '/(WebView|(iPhone|iPod|iPad)(?!.*Safari\/)|Android.*(wv|.0.0.0))/gi';
  return Boolean(useragent.match(regex));
}

const isInGAM = () => {
  try {
    if (window.parent.document) {
      const GAMIframeArray = [...window.parent.document.querySelectorAll('iframe[id^="google_ads_iframe"]')];

      return GAMIframeArray.some(iframe => {
        return iframe.contentDocument === document;
      });
    } else {
      return false;
    }
  } catch(error) {
    return false;
  }
}


/**
 * Verify CTID format
 * @returns {boolean} Verify result
 */
const verifyCtid = ctid => {
  const re = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/;
  const verify = re.exec(`${ctid}`);

  return Boolean(verify);
}

/**
 * check vpon tag attribute format
 * @param {element} vponTag vpon tag element
 * @returns {boolean} result
 */
const checkVponTagAttributes = (vponTag) => {
  const vponTagAttributes = vponTag.getAttributeNames();
  if (!vponTagAttributes.length) {
    console.error("[Vpon-WebSDK] Vpon tag attribute is empty");
    return false;
  }

  let result = true;

  vponTagAttributes.forEach((attribute) => {
    switch (attribute) {
      case websdkParams.vponTagAttrs.licensekey:
        if (
          !websdkParams.regex.licensekey.test(vponTag.getAttribute(attribute))
        ) {
          console.error("[Vpon-WebSDK] Vpon tag lincesekey is invalid");
          result = false;
        }
        break;
      case websdkParams.vponTagAttrs.format:
        if (
          websdkParams.formatMapping.indexOf(
            vponTag.getAttribute(attribute)
          ) === -1
        ) {
          console.error("[Vpon-WebSDK] ad format is invalid");
          result = false;
        }
        break;
    }
  });
  return result;
};

/**
 * Check cookie parameters is valid
 * @param {object} checkObj cookie parameter object
 * @returns {boolean} check result
 */
const cookieParamsValidator = (checkObj = {}) => {
	const { key, value, options } = checkObj;

	if (key && typeof key !== "string") {
		console.warn("[Vpon-WebSDK] Key must be a string!");
		return false;
	}

	if (value && typeof value !== "string") {
		console.warn("[Vpon-WebSDK] Value must be a string!");
		return false;
	}

	if (options && (typeof options !== "object" || Array.isArray(options))) {
		console.warn("[Vpon-WebSDK] Options must be an object!");
		return false;
	}

	return true;
}

// --- <END> check will generate ad or not ---

module.exports = {
  coveredBannerCheck,
  iframeViewable,
  underViewport,
  displayInViewport,
  getFrameBoundingClientRect,
  calIframeBoundingClientRect,
  coveredIntCheck,
  coveredNaCheck,
  getTransferRectWidth,
  getTransferRectHeight,
  checkInput,
  checkAdType,
  checkAttributeIsGiven,
  checkVponTagExisted,
  getReqAdParameters,
  arrangeReqAdUrl,
  currentFrameAbsolutePosition,
  isInCrossDomain,
  queryWebApiPermission,
  isUrl,
  isVpadnEndpoint,
  isWebview,
  isInGAM,
  verifyCtid,
  checkVponTagAttributes,
  cookieParamsValidator
}



// WEBPACK FOOTER //
// ./src/vpadn-sdk-check.partial.js